import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '@/pages/Welcome'
import Overview from '@/pages/academics/Overview'
import UndergradBA from '@/pages/academics/UndergradBA'
import UndergradAccounting from '@/pages/academics/UndergradAccounting'
import Wbb from '@/pages/academics/Wbb'
import BusinessCinematicArts from '@/pages/academics/BusinessCinematicArts'
import RealEstate from '@/pages/academics/RealEstate'
import AIB from '@/pages/academics/AiForBusiness'
import DoubleMajors from '@/pages/academics/DoubleMajors'
import Electives from '@/pages/academics/Electives'
import Faculty from '@/pages/advantages/Faculty'
import ThoughtLeaders from '@/pages/academics/ThoughtLeaders'
import ExperientialLearning from '@/pages/advantages/ExperientialLearning'
import Internships from '@/pages/advantages/Internships'
import ScholarPrograms from '@/pages/advantages/ScholarPrograms'
import StudentOrganizations from '@/pages/life-at-marshall/StudentOrganizations'
import CommunityInvolvement from '@/pages/life-at-marshall/CommunityInvolvement'
import RecreationalSports from '@/pages/life-at-marshall/RecreationalSports'
import GlobalOpportunities from '@/pages/advantages/GlobalOpportunities'
import Thematic from '@/pages/advantages/Thematic'
import WhyLA from '@/pages/life-at-marshall/WhyLA'
import EnjoyingLA from '@/pages/advantages/EnjoyingLA'
import VisitingSpeakers from '@/pages/advantages/VisitingSpeakers'
import Facilities from '@/pages/life-at-marshall/Facilities'
import ResidenceHalls from '@/pages/life-at-marshall/ResidenceHalls'
import SpecialInterestCommunities from '@/pages/life-at-marshall/SpecialInterestCommunities'
import Transportation from '@/pages/life-at-marshall/Transportation'
import NextSteps from '@/pages/NextSteps'
import MarshallUndergraduatePrograms from '@/pages/resources/MarshallUndergraduatePrograms'
import USCAdmitFinaid from '@/pages/resources/USCAdmissions'
import HousingTransportation from '@/pages/resources/HousingTransportation'
import InternationalStudents from '@/pages/resources/InternationalStudents'
import OrientationTours from '@/pages/resources/OrientationTours'
import AcademicResources from '@/pages/resources/AcademicResources'
import Libraries from '@/pages/resources/Libraries'
import AdministrativeServices from '@/pages/resources/AdministrativeServices'
import WellnessSafety from '@/pages/resources/WellnessSafety'
import ResourceStudentOrganizations from '@/pages/resources/ResourceStudentOrganizations'
import AthleticsRecreations from '@/pages/resources/AthleticsRecreations'
import Sitemap from '@/pages/SiteMap'
// import NotFound from '@/pages/NotFound'

Vue.use(Router)

// NOTE: These routes must match the sidenav var in App.vue
// TODO: Should have used meta for the titles, suffixes, and whatnot... oops
// TODO: Should try to get the routes to mimic the nav structure (nested)
export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/sitemap',
      name: 'sitemap',
      component: Sitemap
    },
    {
      path: '/',
      name: 'welcome-congrats',
      component: Welcome
    },
    {
      path: '/academics/overview',
      name: 'academics-overview',
      component: Overview
    },
    {
      path: '/academics/undergraduate-business',
      name: 'academics-undergrad-ba',
      component: UndergradBA
    },
    {
      path: '/academics/undergraduate-accounting',
      name: 'academics-undergrad-accounting',
      component: UndergradAccounting
    },
    {
      path: '/academics/world-bachelor-business',
      name: 'academics-wbb',
      component: Wbb
    },
    {
      path: '/academics/business-cinematic-arts',
      name: 'academics-business-cinematic-arts',
      component: BusinessCinematicArts
    },
    {
      path: '/academics/realestate',
      name: 'academics-realestate',
      component: RealEstate
    },
    {
      path: '/academics/artificial-intelligence-for-business',
      name: 'academics-aib',
      component: AIB
    },
    {
      path: '/academics/double-majors-minors',
      name: 'academics-double-majors',
      component: DoubleMajors
    },
    {
      path: '/academics/electives',
      name: 'academics-electives',
      component: Electives
    },
    {
      path: '/advantages/thematic-option-program-and-scholar-distinctions',
      name: 'advantages-thematic',
      component: Thematic
    },
    {
      path: '/advantages/faculty',
      name: 'academics-faculty',
      component: Faculty
    },
    {
      path: '/academics/thought-leaders',
      name: 'academics-thought-leaders',
      component: ThoughtLeaders
    },
    {
      path: '/advantages/experiential-learning',
      name: 'opportunities-experiential-learning',
      component: ExperientialLearning
    },
    {
      path: '/advantages/careers-internships',
      name: 'opportunities-internships',
      component: Internships
    },
    {
      path: '/advantages/scholar-programs',
      name: 'opportunities-scholar-programs',
      component: ScholarPrograms
    },
    {
      path: '/campus-life/student-organizations',
      name: 'opportunities-student-organizations',
      component: StudentOrganizations
    },
    {
      path: '/campus-life/community-involvement',
      name: 'opportunities-community-involvement',
      component: CommunityInvolvement
    },
    {
      path: '/campus-life/recreational-sports',
      name: 'opportunities-recreational-sports',
      component: RecreationalSports
    },
    {
      path: '/advantages/visiting-speakers',
      name: 'opportunities-visiting-speakers',
      component: VisitingSpeakers
    },
    {
      path: '/advantages/la-advantages',
      name: 'opportunities-why-la',
      component: WhyLA
    },
    {
      path: '/advantages/global-opportunities',
      name: 'opportunities-global-opportunities',
      component: GlobalOpportunities
    },
    {
      path: '/campus-life/enjoying-la',
      name: 'opportunities-enjoying-la',
      component: EnjoyingLA
    },
    {
      path: '/campus-life/facilities',
      name: 'life-facilities',
      component: Facilities
    },
    {
      path: '/campus-life/usc-housing',
      name: 'life-residence-halls',
      component: ResidenceHalls
    },
    {
      path: '/campus-life/special-interest-communities',
      name: 'life-special-interest-communities',
      component: SpecialInterestCommunities
    },
    {
      path: '/campus-life/transportation',
      name: 'life-transportation',
      component: Transportation
    },
    {
      path: '/next-steps',
      name: 'next-steps',
      component: NextSteps
    },
    {
      path: '/resources/marshall-undergraduate-programs',
      name: 'resources-marshall-undergraduate-programs',
      component: MarshallUndergraduatePrograms
    },
    {
      path: '/resources/usc-admissions-finaid-students-accounts',
      name: 'resources-usc-admissions-financial-aid-student-accounts',
      component: USCAdmitFinaid
    },
    {
      path: '/resources/housing-transportation',
      name: 'resources-housing-transportation',
      component: HousingTransportation
    },
    {
      path: '/resources/international-students',
      name: 'resources-international-students',
      component: InternationalStudents
    },
    {
      path: '/resources/orientation-and-tours',
      name: 'resources-oreintation-tours',
      component: OrientationTours
    },
    {
      path: '/resources/academic-resources',
      name: 'resources-academic-resources',
      component: AcademicResources
    },
    {
      path: '/resources/libraries',
      name: 'resources-libraries',
      component: Libraries
    },
    {
      path: '/resources/administrative-services',
      name: 'resources-administrative-services',
      component: AdministrativeServices
    },
    {
      path: '/resources/wellness-safety',
      name: 'resources-wellness-safety',
      component: WellnessSafety
    },
    {
      path: '/resources/student-organizations',
      name: 'resources-student-organizations',
      component: ResourceStudentOrganizations
    },
    {
      path: '/resources/athletics-recreation',
      name: 'resources-athletics-recreations',
      component: AthleticsRecreations
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js